export default {
    delivery: {
        product: {
            tracking: "Śledzenie",
            quantity: "Ilość"
        }
    }
}